module.exports = "/packs/images/svg/facilities/softplay~cedfe11847aed55d82d0a41515656a83.svg";